<div class="toast-container">
  <div class="toast" fxLayout="column" raUiToast [toastConfig]="toastConfig" (onButtonClick)="btnClick($event)"></div>
</div>
@if (displayMessage$ | async) {}
